import { render, staticRenderFns } from "./BookingForm.vue?vue&type=template&id=22c85dae&"
import script from "./BookingForm.vue?vue&type=script&lang=ts&"
export * from "./BookingForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports